module.exports = __webpack_public_path__ + "static/12-c1264f5d7522312af9c387cbefe59a67.mp4";